import { createPinia } from "pinia"
import '@tritt/components/dist/theme.css'
// import './css/index.css'
import 'uno.css'
// import 'virtual:uno.css'
import './css/style.css'
// import 'virtual:uno.css'

const appNode = '#app'

const mountApp = async () => {
  const pinia = createPinia()

  const loadingApp = await import('./loadingApp')
  const loadingAppInstance = await loadingApp.createApp(pinia)
  loadingAppInstance.mount(appNode)

  const mainApp = await import('./mainApp')
  const mainAppInstance = await mainApp.createApp(pinia)

  loadingAppInstance.unmount()
  mainAppInstance.mount(appNode)
}

mountApp()
